module.exports = __webpack_public_path__ + "img/765-b078bd.png";